import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { Guid } from '@web/utils';
import {
  TableBuilderFactory,
  TableComponent,
  TableConfig,
  TableDataPayload,
} from '@web/shared/ui';
import { Observable } from 'rxjs';
import { AdminBoxQuantityHistoryListCustomCellTemplateComponent } from '../../components/admin-box-quantity-history-list-custom-cell-template/admin-box-quantity-history-list-custom-cell-template.component';
import { AdminBoxQuantityHistoryListItemAction } from '../../enums/admin-box-quantity-history-list-item-action';
import { AdminBoxQuantityHistoryCollectionFilter } from '../../models/admin-box-quantity-history-collection-filter';
import { AdminBoxQuantityHistoryCollectionItem } from '../../models/admin-box-quantity-history-collection-item';
import { AdminBoxQuantityHistoryReasonTypeProviderService } from '../../providers/admin-box-quantity-history-reason-type-provider.service';
import { AdminBoxDataSourceService } from '@web/features/box';

@Component({
  selector: 'app-admin-box-quantity-history-list',
  imports: [
    AdminBoxQuantityHistoryListCustomCellTemplateComponent,
    TableComponent,
  ],
  templateUrl: './admin-box-quantity-history-list.component.html',
  styleUrl: './admin-box-quantity-history-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminBoxQuantityHistoryListComponent {
  /* prettier-ignore */
  private readonly tableBuilder = inject(TableBuilderFactory<AdminBoxQuantityHistoryCollectionItem, AdminBoxQuantityHistoryCollectionFilter, AdminBoxQuantityHistoryListItemAction>).create();
  /* prettier-ignore */
  private readonly reasonTypeProvider = inject(AdminBoxQuantityHistoryReasonTypeProviderService);
  private readonly dataSource = inject(AdminBoxDataSourceService);

  public readonly id = input.required<Guid>();

  protected readonly config = this.buildTable();

  private buildTable(): TableConfig<
    AdminBoxQuantityHistoryCollectionItem,
    AdminBoxQuantityHistoryCollectionFilter,
    AdminBoxQuantityHistoryListItemAction
  > {
    // prettier-ignore
    return this.tableBuilder
      .dataKey('id')
      .columns((builder) => [
        builder
          .initCustom('change')
          .width('14rem')
          .label('Ilość')
          .build(),

        builder
          .initCustom('createdAt')
          .width('14rem')
          .filterKey('createdAt')
          .sortKey('createdAt')
          .label('Data zmiany')
          .build(),

        builder
          .initText('createdBy')
          .width('16rem')
          .filterKey('createdBy')
          .sortKey('createdBy')
          .label('Autor')
          .build(),

        builder
          .initCustom('reason')
          .width('18rem')
          .filterKey('reason')
          .sortKey('reason')
          .label('Powód zmiany')
          .build(),

        builder
          .initCustom('order')
          .width('20rem')
          .filterKey('order')
          .sortKey('order')
          .label('Zamówienie')
          .build(),
      ])
      .filters((builder) => [
        builder
          .initNumber('change')
          .build(),
        builder
          .initSelect('reason')
          .dictionary(() => this.reasonTypeProvider.selectItems())
          .build(),
        builder
          .initDateRange('createdAt')
          .build(),
        builder
          .initText('createdBy')
          .build(),
        builder
          .initText('order')
          .build(),
      ])
      .dataSource({ fetch: (lazyLoad): Observable<TableDataPayload<AdminBoxQuantityHistoryCollectionItem>> => this.dataSource.fetchQuantityHistoryCollection(this.id(), lazyLoad)})
      .build();
  }
}
